<template>
    <main
        :class="[
            'card m-0 flex h-screen w-screen items-center justify-center p-0',
            'bg-[url(/pagu-background-woman-small.jpg)]',
            'bg-cover bg-center',
        ]"
    >
        <Card>
            <template #header>
                <div class="m-4 mb-0 flex flex-col items-center justify-center gap-4">
                    <BoServiceLogo />
                    <div class="flex w-full flex-col gap-4 sm:w-56">
                        <h1 class="w-full text-center text-[1.4rem]">
                            {{ $t('project-name') }}
                        </h1>
                    </div>
                </div>
            </template>
            <template #content>
                <Button
                    type="button"
                    @click.prevent="auth.explicitLogin"
                    severity="primary"
                    class="flex w-full"
                >
                    {{ $t('auth.login') }}
                </Button>
            </template>
        </Card>
    </main>
</template>

<script setup lang="ts">
    import useAuthStore from '@/stores/useAuthStore';
    import Button from 'primevue/button';
    import Card from 'primevue/card';

    const auth = useAuthStore();
</script>
